import i18n from '@/locales'
import { getEnabledSwitchActions } from '@/utils/common/tableActions'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('report.set_field'),
        permission: 'report_settings_perform_add_elements',
        action: (obj) => {
          this.createDialog('ReportSettingCreateDialog', {
            data: [obj],
            type: 'set-elements',
            columns: this.columns,
            onManager: this.onManager,
          })
        },
        meta: (obj) => {
          return this.checkSameDomain(obj)
        },
      },
      {
        label: i18n.t('common.more'),
        actions: (obj) => {
          return [
            // 启用禁用
            ...getEnabledSwitchActions(this, obj, ['report_settings_perform_enable', 'report_settings_perform_disable'], {
              metas: [
                () => {
                  const ret = {
                    validate: !obj.enabled,
                  }
                  if (ret.validate) {
                    return this.checkSameDomain(obj)
                  }
                  return ret
                },
                () => {
                  const ret = {
                    validate: obj.enabled,
                  }
                  if (ret.validate) {
                    return this.checkSameDomain(obj)
                  }
                  return ret
                },
              ],
              resourceName: this.$t('report.report_setting'),
              fields: ['name', 'enabled', 'cron_expression'],
            }),
            {
              label: i18n.t('report.gen_report'),
              permission: 'report_settings_perform_generate_report',
              action: (obj) => {
                this.generateReportValue(obj)
              },
              meta: (obj) => {
                const ret = { validate: true }
                if (!(obj.elements && obj.elements.length) && ret.validate) {
                  ret.validate = false
                  ret.tooltip = this.$t('report.no_has_report_elements')
                }
                if (!obj.enabled && ret.validate) {
                  ret.validate = false
                  ret.tooltip = this.$t('report.please_enable_report_setting')
                }
                if (ret.validate) {
                  return this.checkSameDomain(obj)
                }
                return ret
              },
            },
            {
              label: i18n.t('common.action.delete'),
              permission: 'report_settings_delete',
              action: () => {
                this.createDialog('DeleteResDialog', {
                  name: i18n.t('report.report_setting'),
                  title: i18n.t('common.action.delete'),
                  vm: this,
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                const ret = { validate: true }
                if (['default_domain_report', 'default_project_report'].includes(obj.id)) {
                  ret.validate = false
                  ret.tooltip = this.$t('report.default_report_not_delete')
                  return ret
                }
                if (ret.validate) {
                  return this.checkSameDomain(obj)
                }
                return ret
              },
            },
          ]
        },
      },
    ]
  },
  methods: {
    async generateReportValue (data) {
      try {
        await this.onManager('batchPerformAction', {
          id: [data.id],
          managerArgs: {
            action: 'generate-report',
          },
        })
        this.$message.success(this.$t('common_360'))
      } catch (err) {
        throw err
      }
    },
    checkSameDomain (data) {
      const ret = { validate: true }
      const { domain_id } = data
      if (!this.$store.getters.isAdminMode && domain_id !== this.$store.getters.userInfo.projectDomainId) {
        ret.validate = false
        ret.tooltip = this.$t('common_716')
      }
      return ret
    },
  },
}
